import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=209bd573&scoped=true"
import script from "./Authenticate.vue?vue&type=script&lang=js"
export * from "./Authenticate.vue?vue&type=script&lang=js"
import style0 from "./Authenticate.vue?vue&type=style&index=0&id=209bd573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209bd573",
  null
  
)

export default component.exports